<div class="confirmation-modal-wrapper">
  <app-base-modal [dialogTitle]="data.title ?? ''" (closeEvent)="onCancel()">
    <p>{{ data.content }}</p>
    <br />

    <!-- This is projected by the ng-content of the app-base-modal -->
    <div panel-footer>
      <button mat-flat-button class="button-link" (click)="onCancel()">Cancel</button>
      <button mat-flat-button class="button-primary" (click)="onConfirm()">
        {{ data.confirmButtonText ?? 'Confirm' }}
      </button>
    </div>
  </app-base-modal>
</div>
